import { Injectable } from '@angular/core';

// External modules
import { saveAs } from 'file-saver';

// Angular material
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

// Custom components
import { CustomSnackbarComponent } from '../../components/utils/custom-snackbar/custom-snackbar.component';

// Generic dialogs
import { InformationPopupComponent } from '../../components/popups/information-popup/information-popup.component';
import { DecisionPopupComponent } from '../../components/popups/decision-popup/decision-popup.component';
import { PatientIdPopupComponent } from '../../components/popups/patient-id-popup/patient-id-popup.component';
import { FileNamePopupComponent } from '../../components/popups/file-name-popup/file-name-popup.component';


@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private _snackBar: MatSnackBar,
    public dialog:MatDialog,
  ) {}


  // ---------- Dictionary deep copy ---------- //
  deepCopyDict(inputArray:any){
    // return structuredClone(object)   -> Right way, still beta. Will be out soon
    return JSON.parse(JSON.stringify(inputArray));
  }

  
  // ---------- Snack bar ---------- //
  displaySnackBar(message:string, duration:number=3000){
    this._snackBar.open(message, '', {
      duration: duration,
      horizontalPosition:'center',
      verticalPosition:'bottom',
    });
  }




  displayCustomSnackBar(message:string) {
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      duration: 500,
      panelClass: 'custom-snackbar-text-center',
      horizontalPosition: 'center',
      data: {message: message}
    });
  }



  dictionaryToFormData(dataDict:any){
    let formData = new FormData();
    for (const key in dataDict) {
      if (Object.prototype.hasOwnProperty.call(dataDict, key)) {
        const valor = dataDict[key];
        formData.append(key, valor);
      }
    }
    return formData
  }


  downloadFile(url: string, filename: string) {
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.blob();
        })
        .then(blob => {
            saveAs(blob, filename);
        })
        .catch(error => console.error(error));
  }

  /*
  async fetchBinaryFile(url: string): Promise<any> {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.arrayBuffer();
      })
      .then(buffer => {
        return {resultOk: true, data: new Uint8Array(buffer)};
      })
      .catch(error => {
        console.error(error);
        return {resultOk: false, error: error};
      });
  }
  */


  async fetchMultipleFiles(urls: string[]): Promise<{resultOk: boolean, data: Uint8Array[], error: any}> {
    try {
        const promises = urls.map(url => this.fetchBinaryFile(url));
        const results = await Promise.all(promises);
        return { resultOk: true, data: results, error: null };
    } catch (error) {
        console.error("Error durante la descarga de los archivos:", error);
        return { resultOk: false, data: [], error: error.message || error.toString() };
    }
  }
  async fetchBinaryFile(url: string): Promise<Uint8Array> {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const buffer = await response.arrayBuffer();
    return new Uint8Array(buffer);
  }




  // Gets higher power of 2 smaller than the x number
  // If x<2, returns 1
  highestPowerOfTwo(x: number): number {
    if (x < 2) {
      return 1; 
    }
    return 2 ** Math.floor(Math.log2(x));
  }



  // ----- Generic Dialogs ----- //

  displayInformationPopupComponent(popupTitle:string, popupText:string){
    this.dialog.open(
      InformationPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',  
        //height: '500px', 
      } 
    )
  }

  displayDecisionPopupComponent(popupTitle:string, popupText:string, targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      DecisionPopupComponent, 
      {
        disableClose: true,
        data: {popupTitle:popupTitle, popupText:popupText},
        width: '500px',  
        //height: '500px', 
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }

  displayPatientIdPopup(targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      PatientIdPopupComponent, 
      {
        disableClose: true,
        data: {proposedPatientId:'', proposedStudyId:''},
        width: '500px',  
        //height: '500px', 
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }

  displayFileNamePopup(targetCallbackMethod: (data: any) => void){
    this.dialog.open(
      FileNamePopupComponent, 
      {
        disableClose: true,
        data: {proposedFileName:''},
        width: '500px',  
        //height: '500px', 
      } 
    ).afterClosed().subscribe(result => targetCallbackMethod(result))
  }


  

  


}
